import { render } from "./SpinnerSVG.vue?vue&type=template&id=4d81b72f&scoped=true"
const script = {}

import "./SpinnerSVG.vue?vue&type=style&index=0&id=4d81b72f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d81b72f"]])

export default __exports__